import { useState } from "react";

import * as inputValidation from "../../../utils/inputValidationUtils";
import FormButtonsForCloseAndSubmit from "../../Common/Forms/FormButtonsForCloseAndSubmit";
import FromToDatePickerNative from "../../Common/Forms/FromToDatePickerNative";
import TextInput from "../../Common/Forms/TextInput";

// Adapt event-like onChange from native pickers to existing handleChange(name, value)
const handleEventChange = (e, handleChange) => {
  handleChange(e.target.name, e.target.value);
};

const handleMakuleringDatoValidationChange = (
  variableName,
  errorText,
  handleChange,
) => {
  if (variableName === "fraDatoValidationErrorText") {
    handleChange("makuleringFraDatoValidationErrorText", errorText);
  } else if (variableName === "tilDatoValidationErrorText") {
    handleChange("makuleringTilDatoValidationErrorText", errorText);
  }
};

const handleIleggelseDatoValidationChange = (
  variableName,
  errorText,
  handleChange,
) => {
  if (variableName === "fraDatoValidationErrorText") {
    handleChange("ileggelseFraDatoValidationErrorText", errorText);
  } else if (variableName === "tilDatoValidationErrorText") {
    handleChange("ileggelseTilDatoValidationErrorText", errorText);
  }
};

const valueExistsValidation = (
  makuleringFraDato,
  makuleringTilDato,
  ileggelseFraDato,
  ileggelseTilDato,
  tjenestenummer,
  makulertAv,
  handleChange,
) => {
  if (
    makuleringFraDato ||
    makuleringTilDato ||
    ileggelseFraDato ||
    ileggelseTilDato ||
    tjenestenummer ||
    makulertAv
  ) {
    handleChange("filterValidationErrorText", null);
    return true;
  } else {
    handleChange(
      "filterValidationErrorText",
      "Dato, tjenestenummer eller makulert av må være utfylt",
    );
    return false;
  }
};

const fraDateTimeTilDateTimeValidations = (
  makuleringFraDato,
  makuleringTilDato,
  ileggelseFraDato,
  ileggelseTilDato,
  handleChange,
) => {
  let makuleringFraDateTimeTilDateTimeValidation =
    inputValidation.fraDateTimeTilDateTimeValidation(
      {
        fraDato: makuleringFraDato,
        tilDato: makuleringTilDato,
      },
      (variableName, errorText) =>
        handleMakuleringDatoValidationChange(
          variableName,
          errorText,
          handleChange,
        ),
    );

  let ileggelseFraDateTimeTilDateTimeValidation =
    inputValidation.fraDateTimeTilDateTimeValidation(
      {
        fraDato: ileggelseFraDato,
        tilDato: ileggelseTilDato,
      },
      (variableName, errorText) =>
        handleIleggelseDatoValidationChange(
          variableName,
          errorText,
          handleChange,
        ),
    );

  return (
    makuleringFraDateTimeTilDateTimeValidation &&
    ileggelseFraDateTimeTilDateTimeValidation
  );
};

const tjenestenummerValidation = (tjenestenummer, handleChange) => {
  if (tjenestenummer === "") {
    handleChange("tjenestenummerValidationErrorText", null);
    return true;
  }
  const validationErrorText =
    inputValidation.mustBeAPositiveInteger(tjenestenummer);
  if (validationErrorText) {
    handleChange("tjenestenummerValidationErrorText", validationErrorText);
    return false;
  }
  handleChange("tjenestenummerValidationErrorText", null);
  return true;
};

const isValid = (makuleringerFilterForm, handleChange) => {
  return (
    valueExistsValidation(
      makuleringerFilterForm.makuleringFraDato,
      makuleringerFilterForm.makuleringTilDato,
      makuleringerFilterForm.ileggelseFraDato,
      makuleringerFilterForm.ileggelseTilDato,
      makuleringerFilterForm.tjenestenummer,
      makuleringerFilterForm.makulertAv,
      handleChange,
    ) &&
    fraDateTimeTilDateTimeValidations(
      makuleringerFilterForm.makuleringFraDato,
      makuleringerFilterForm.makuleringTilDato,
      makuleringerFilterForm.ileggelseFraDato,
      makuleringerFilterForm.ileggelseTilDato,
      handleChange,
    ) &&
    tjenestenummerValidation(
      makuleringerFilterForm.tjenestenummer,
      handleChange,
    )
  );
};

const handleSubmit = (
  e,
  makuleringerFilterForm,
  handleChange,
  handleChangeAll,
  getRapportMakuleringer,
  setShowSokSpinner,
) => {
  e.preventDefault();
  if (isValid(makuleringerFilterForm, handleChange)) {
    setShowSokSpinner(true);
    getRapportMakuleringer({
      makuleringFraDato: makuleringerFilterForm.makuleringFraDato,
      makuleringTilDato: makuleringerFilterForm.makuleringTilDato,
      ileggelseFraDato: makuleringerFilterForm.ileggelseFraDato,
      ileggelseTilDato: makuleringerFilterForm.ileggelseTilDato,
      tjenestenummer: makuleringerFilterForm.tjenestenummer,
      makulertAv: makuleringerFilterForm.makulertAv,
    })
      .then(() => {
        setShowSokSpinner(false);
        handleChangeAll("RAPPORT_MAKULERINGER_SUBMITTED_FORM", {
          makuleringFraDato: makuleringerFilterForm.makuleringFraDato,
          makuleringTilDato: makuleringerFilterForm.makuleringTilDato,
          ileggelseFraDato: makuleringerFilterForm.ileggelseFraDato,
          ileggelseTilDato: makuleringerFilterForm.ileggelseTilDato,
          tjenestenummer: makuleringerFilterForm.tjenestenummer,
          makulertAv: makuleringerFilterForm.makulertAv,
          submitTimestamp: new Date(),
        });
      })
      .catch(() => setShowSokSpinner(false));
  }
};

const MakuleringFilterForm = ({
  makuleringerFilterForm,
  handleChange,
  handleChangeAll,
  handleChangeToInitState,
  getRapportMakuleringer,
}) => {
  const [showSokSpinner, setShowSokSpinner] = useState(false);

  return (
    <form
      className="rapportSearch SearchHistorikkForm"
      onSubmit={(e) =>
        handleSubmit(
          e,
          makuleringerFilterForm,
          handleChange,
          handleChangeAll,
          getRapportMakuleringer,
          setShowSokSpinner,
        )
      }
    >
      <div className="searchHistorikkOverskrift">Søk etter makuleringer</div>
      <div className="filter-flexbox-container ventilstilling-filter-flexbox">
        <FromToDatePickerNative
          fra={{
            id: "makuleringFraDato",
            name: "makuleringFraDato",
            label: "Makulert dato fra",
            placeholder: "Velg dato",
            value: makuleringerFilterForm.makuleringFraDato,
            validationError:
              makuleringerFilterForm.makuleringFraDatoValidationErrorText,
          }}
          til={{
            id: "makuleringTilDato",
            name: "makuleringTilDato",
            label: "Makulert dato til",
            placeholder: "Velg dato",
            value: makuleringerFilterForm.makuleringTilDato,
            validationError:
              makuleringerFilterForm.makuleringTilDatoValidationErrorText,
          }}
          onChange={(e) => handleEventChange(e, handleChange)}
        />
        <FromToDatePickerNative
          fra={{
            id: "ileggelseFraDato",
            name: "ileggelseFraDato",
            label: "Ileggelsesdato fra",
            placeholder: "Velg dato",
            value: makuleringerFilterForm.ileggelseFraDato,
            validationError:
              makuleringerFilterForm.ileggelseFraDatoValidationErrorText,
          }}
          til={{
            id: "ileggelseTilDato",
            name: "ileggelseTilDato",
            label: "Ileggelsesdato til",
            placeholder: "Velg dato",
            value: makuleringerFilterForm.ileggelseTilDato,
            validationError:
              makuleringerFilterForm.ileggelseTilDatoValidationErrorText,
          }}
          onChange={(e) => handleEventChange(e, handleChange)}
        />
        <TextInput
          label="Tjenestenummer"
          name="tjenestenummer"
          onChange={(e) => handleChange(e.target.name, e.target.value)}
          value={makuleringerFilterForm.tjenestenummer}
          validationError={
            makuleringerFilterForm.tjenestenummerValidationErrorText
          }
        />
        <TextInput
          label="Makulert av"
          name="makulertAv"
          onChange={(e) => handleChange(e.target.name, e.target.value)}
          value={makuleringerFilterForm.makulertAv}
        />
      </div>
      <div style={{ color: "#a94442" }}>
        {makuleringerFilterForm.filterValidationErrorText &&
          makuleringerFilterForm.filterValidationErrorText}
      </div>
      <div style={{ marginTop: 10 }}>
        <FormButtonsForCloseAndSubmit
          closeText="Tilbakestill"
          submitText="Søk"
          onClose={() =>
            handleChangeToInitState("RAPPORT_MAKULERINGER_FILTER_FORM")
          }
          onSubmit={() => {}}
          showCloseSpinner={false}
          showSubmitSpinner={showSokSpinner}
        />
      </div>
    </form>
  );
};

export default MakuleringFilterForm;
